<template>
  <div id="offline-platform">
    <div v-if="!whatsappStatus">
      <whatsapp-offline></whatsapp-offline>
    </div>
    <div v-else-if="maintenanceStatus">
      <maintenance></maintenance>
    </div>
  </div>
</template>

<script>
  import WhatsappOffline from "@/views/offline-platform/Types/WhatsappOffline.vue";
  import Maintenance from "@/views/offline-platform/Types/Maintenance.vue";

  export default {
    name: 'offline',
    components: { Maintenance, WhatsappOffline },
    data() {
      return {}
    },
    computed:{
      whatsappStatus() {
        return this.$store.state.whatsappStatus;
      },
      maintenanceStatus() {
        return this.$store.state.offlinePlatform;
      }
    }
  }
</script>

<style lang="scss">
  .offline-message {
    height: calc(100vh - 300px);
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    text-align: center;

    p {
      width: 100%;
      display: block;
      font-size: 24px;
      line-height: 74px;
    }
  }
</style>
